import { render, staticRenderFns } from "./AccessPopup.vue?vue&type=template&id=50e6fcb1"
import script from "./AccessPopup.vue?vue&type=script&lang=js"
export * from "./AccessPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports